import * as React from "react";
import { forwardRef } from "react";
const SvgRecording = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 16.6667L5 23.3333M12.5 10L12.5 30M20 5V35M27.5 10V30M35 16.6667V23.3333", stroke: "#145362", strokeWidth: 2.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgRecording);
export { ForwardRef as ReactComponent };
